import { IonButton } from '@ionic/react';
import styled from 'styled-components';

export const ForgotYourPasswordButton = styled(IonButton)`
  font-size: 0.75em;
  font-family: 'Inter';
  --background-hover-opacity: 0%;
  --color-activated: ;
  --color-focused: rgba(var(--ion-color-primary-rgb), 0.4);
  --background-focused: rgba(var(--ion-color-primary-rgb), 0.4);
`;
